import { render, staticRenderFns } from "./ExceptionLog.vue?vue&type=template&id=24877cc4"
import script from "./ExceptionLog.vue?vue&type=script&lang=js"
export * from "./ExceptionLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports